module.exports = __webpack_public_path__ + "img/pousada-aguape.36c5c83c.jpg";